import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth, LoginPage, SetupTotpPage, VerifyTotpPage } from "./AuthGuard";
import { Dashboard } from "./Dashboard";
import Backtest from "./Backtest";

export default function App() {
  const {
    user, loading, error, step, qrCode,
    login, verificarTotp, logout,
  } = useAuth();

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="w-12 h-12 rounded-2xl bg-purple-600 flex items-center justify-center mx-auto mb-3 animate-pulse">
          <span className="text-white font-black text-xl">M</span>
        </div>
        <p className="text-gray-400 text-sm">Carregando...</p>
      </div>
    </div>
  );

  if (step === "totp_setup")
    return <SetupTotpPage qrCode={qrCode} onVerify={verificarTotp} error={error}/>;

  if (step === "totp_verify")
    return <VerifyTotpPage onVerify={verificarTotp} error={error}/>;

  if (!user)
    return <LoginPage onLogin={login} error={error}/>;

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/backtest"
          element={<Backtest user={user} onLogout={logout} />}
        />
        <Route
          path="/"
          element={<Dashboard user={user} onLogout={logout} />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
